import React from 'react';
import { Accordion, Nav } from 'react-bootstrap';
import {
  Dashboard as DashboardIcon,
  LocalOffer as OfferIcon,
  Bookmark as ShortlistIcon,
  QuestionAnswer as QueryIcon,
  Gavel as BafoIcon,
  Assignment as RequirementIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const SidebarBuyer = ({ selectedFilter, handleDataFilterChange }) => {
  const topOptions = [
    { value: '', label: 'Dashboard', icon: <DashboardIcon /> },
    { value: 'All Offers', label: 'All Offers', icon: <OfferIcon /> },
    { value: 'Shortlisted Offers', label: 'Shortlisted Offers', icon: <ShortlistIcon /> },
    { value: 'Queried Offers', label: 'Queried Offers', icon: <QueryIcon /> },
    { value: 'BAFO', label: 'BAFO', icon: <BafoIcon /> },
    { value: 'Requirement', label: 'Requirement', icon: <RequirementIcon /> },
  ];

  const handleClick = (value) => {
    const event = { target: { value } };
    handleDataFilterChange(event);
  };

  // Styled component for the nav link to align icon and text
  const NavLinkWrapper = styled('span')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1), // Space between icon and text
    padding: '13px 0 13px 15px', // Updated padding: 20px top and bottom, 0px left and right
    cursor: 'pointer',
    fontSize: '14px', // Set font size to 14px
    '&:hover': {
      backgroundColor: theme.palette.action.hover, // Hover effect
    },
    '&.active': {
      backgroundColor: theme.palette.action.selected, // Active state
      fontWeight: theme.typography.fontWeightBold,
      '& .MuiSvgIcon-root': {
        color: 'rgb(222, 107, 20)', // Icon color for active state
      },
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff', // Default icon color (white)
    },
  }));

  return (
    <aside
      className="left-panel text-white"
      style={{  width: '250px', backgroundColor: '#2c3e50' }}
    >
      <div className="offers-filter-options">
        <ul className="nav flex-column">
          {topOptions.map((option) => (
            <li
              key={option.value}
              className={`nav-item ${selectedFilter === option.value ? 'active' : ''}`}
              onClick={() => handleClick(option.value)}
            >
              <NavLinkWrapper className={selectedFilter === option.value ? 'active' : ''}>
                {option.icon}
                <span>{option.label}</span>
              </NavLinkWrapper>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
};

export default SidebarBuyer;